
/// <amd-module name="Search/Shared/Components/ResultsInfo/index" />
export * from "Search/Shared/Components/ResultsInfo/ResultsInfo";
export * from "Search/Shared/Components/ResultsInfo/ResultsInfo.Props";
